import {
  SubscriptionFeature as SubscriptionFeatureDto,
  SubscriptionFeatureType,
} from '@content-api/api/subscription';
import { Skeleton } from '@ui/components';
import { FC } from 'react';

import { SubscriptionFeature } from './subscription-feature';

interface SubscriptionFeaturesListProps {
  features?: SubscriptionFeatureDto[];
  isLoading?: boolean;
  className?: string;
  code?: string;
}

export const SubscriptionFeaturesList: FC<SubscriptionFeaturesListProps> = ({
  className,
  isLoading,
  features,
  code,
}) => {
  if (isLoading) {
    return (
      <>
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full mt-8 mb-auto" />
      </>
    );
  }

  const primaryFeatures = features?.filter(
    (feature) => feature.type === SubscriptionFeatureType.PRIMARY,
  );
  const secondaryFeatures = features?.filter(
    (feature) => feature.type === SubscriptionFeatureType.SECONDARY,
  );

  return (
    <div className={className}>
      {primaryFeatures && primaryFeatures.length > 0 && (
        <div className="flex flex-col gap-4">
          {primaryFeatures.map((feature) => (
            <SubscriptionFeature key={`${code}-${feature.id}`} {...feature} />
          ))}
        </div>
      )}

      {secondaryFeatures && secondaryFeatures.length > 0 && (
        <div className="flex flex-col gap-2 mt-6">
          {secondaryFeatures.map((feature) => (
            <SubscriptionFeature key={`${code}-${feature.id}`} {...feature} />
          ))}
        </div>
      )}
    </div>
  );
};
